import { render, staticRenderFns } from "./panel-button-settings.vue?vue&type=template&id=4e0ceb8b&"
import script from "./panel-button-settings.vue?vue&type=script&lang=js&"
export * from "./panel-button-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports